module.exports = __webpack_public_path__ + "static/media/Manatee.f63e3524.svg";